import { ChevronRightIcon } from '@heroicons/react/20/solid'
import cx from 'classix'
import React from 'react'

type Props = {
  title: string
  href: string
  font?: keyof typeof fontVariants
  className?: string
}

const fontVariants = {
  bold: 'font-bold',
  normal: 'font-normal',
}

export default function MobileMenuLink({ title, href, className, font = 'bold' }: Props) {
  return (
    <a
      className={cx('hover:underline flex items-center w-full', className, fontVariants[font])}
      href={href}
    >
      <span className='leading-mid text-xl'>{title}</span>
      <ChevronRightIcon className='ml-2 h-4 w-4' />
    </a>
  )
}
